//messages.js
export default {
    product_id: "Producto",
    product_name: "Nombre del producto",
    specific_gravity: "Gravedad específica",
};
